import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogBody,
} from '../../../../components/ui/Dialog';
import Button from '../../../../components/ui/Button';
import AppIcon from '../../../../components/AppIcon';

interface SubmissionConfirmationProps {
  open: boolean;
  onClose: () => void;
}

const SubmissionConfirmation: React.FC<SubmissionConfirmationProps> = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent size="lg" hideCloseButton>
        <DialogBody>
          <h2 className="text-2xl font-semibold text-foreground mb-8 mt-2">
            {t('performance.espn.surveyTitle')}
          </h2>

          <div className="text-center py-6">
            <div className="w-20 h-20 rounded-full bg-emerald-100 dark:bg-emerald-900/30 mx-auto mb-6 flex items-center justify-center">
              <AppIcon name="CheckCircle2" size={48} className="text-emerald-500" />
            </div>

            <h3 className="text-3xl font-semibold text-foreground mb-4">
              {t('performance.espn.thankYou')}
            </h3>

            <p className="text-lg text-muted-foreground mb-8 max-w-[600px] mx-auto">
              {t('performance.espn.feedbackSubmitted')}
            </p>

            <div className="bg-card border border-border rounded-lg p-6 max-w-[700px] mx-auto mb-6 shadow-sm">
              <p className="text-sm font-medium text-foreground mb-4">
                {t('performance.espn.whatHappensNext')}
              </p>
              <ul className="space-y-2 text-start">
                <li className="text-sm text-muted-foreground">
                  &bull; {t('performance.espn.nextStep1')}
                </li>
                <li className="text-sm text-muted-foreground">
                  &bull; {t('performance.espn.nextStep2')}
                </li>
                <li className="text-sm text-muted-foreground">
                  &bull; {t('performance.espn.nextStep3')}
                </li>
                <li className="text-sm text-muted-foreground">
                  &bull; {t('performance.espn.nextStep4')}
                </li>
              </ul>
            </div>

            <Button onClick={onClose} className="max-w-[300px] mx-auto mt-4" fullWidth>
              {t('common.close')}
            </Button>
          </div>
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
};

export default SubmissionConfirmation;
